import styled from "styled-components";

const H5 = styled.h5`
    /*font-weight: 400;*/
    letter-spacing: 0;
    font-size: 1.25rem;
    margin: 0;
`;

export default H5;
